"use client";

import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "../../lib/utils";

const Separator = ({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) => (
  <SeparatorPrimitive.Root
    data-slot="separator"
    decorative={decorative}
    orientation={orientation}
    className={cn(
      "jobsite:bg-border jobsite:shrink-0 jobsite:data-[orientation=horizontal]:h-px jobsite:data-[orientation=horizontal]:w-full jobsite:data-[orientation=vertical]:h-full jobsite:data-[orientation=vertical]:w-px",
      className,
    )}
    {...props}
  />
);

export { Separator };
